import Deepdive from './views/deepdive/Deepdive';
import Essentials from './views/essentials/Essentials';
import FAQ from './views/faq/FAQ';
import Helpfullinks from './views/helpfullinks/Helpfullinks';
import Countries from './views/countries/Countries'
import Country from './views/country/Country';
import Main from './layout/Main';
import Minimial from './layout/Minimal';

export default   [
     {
      pageLink: '/',
      view: Country,
      displayName: 'Home',
      layout: Main,
    //  animationDelayForNavbar: 0.8,
      showInNavbar: false,
    },
    
    {
      pageLink: '/deepdive',
      view: Deepdive,
      displayName: 'Deep Dive',
      layout : Minimial,
      //animationDelayForNavbar: 0.4,
      showInNavbar: true,
    },
    {
      pageLink: '/helpfullinks',
      view: Helpfullinks,
      layout : Minimial,
      displayName: 'Helpful Links',
     // animationDelayForNavbar: 0.5,
      showInNavbar: true,
    },
    {
      pageLink: '/essentials',
      view: Essentials,
      displayName: 'Essentials',
      layout : Minimial,
     // animationDelayForNavbar: 0.6,
      showInNavbar: true,
    },
    {
      pageLink: '/faq',
      view: FAQ,
      displayName: 'FAQ',
      layout : Minimial,
     // animationDelayForNavbar: 0.7,
      showInNavbar: true,
    },
    {
      pageLink: "/covid19/country/:country",
      view: Country,
      displayName: '',
      layout: Main,
    //  animationDelayForNavbar: 0.8,
      showInNavbar: true,
    },

   
    {
      pageLink: '/covid19/country',
      view: Countries,
      displayName: 'All Countries',
      layout : Main,
     // animationDelayForNavbar: 0.2,
      showInNavbar: true,
    },
  ];
